var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeItemConfig)?_c('data-item',{staticStyle:{"margin-left":"-1rem","margin-right":"1rem"},attrs:{"dataParm":{id: _vm.dataId},"isDetail":true,"config":_vm.typeItemConfig}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }